package ru.malygin.urls.url

class GetDataByNameFromDatabase {
    val urlHead = "/getDataByNameFromDatabase"
}